import { render } from "./CustomersList.vue?vue&type=template&id=78660129"
import script from "./CustomersList.vue?vue&type=script&lang=js"
export * from "./CustomersList.vue?vue&type=script&lang=js"
script.render = render

export default script